import SB2Sort from "components/Input/SB2Sort"
import { BUILDER_CONFIG, CONFIG_CUSTOMIZATION, CUSTOMIZATION_THEME_SETTINGS, FRMDATA_CATEGORY_THUMBNAIL, FRMDATA_IMAGE_DISPLAY, PAGE_LAYOUT, PAGE_LAYOUTS, THEME_TITLE } from "constants/constants"
import { useAppContext } from "contexts/AppContext"
import { Dispatch, SetStateAction } from "react"
import { TUI_Node } from "types"

type MyProps = {
    title?: string
    altTitle?: string
    showSort?: boolean
    category?: TUI_Node
    isRequired?: boolean
    className?: string
    categorySort: string
    setCategorySort: Dispatch<SetStateAction<string>>
}

const CategoryTitle = (props: MyProps) => {
    const {
        builderSpec,
        activePage
    } = useAppContext()

    return (
        <div className={`sb3-flex sb3-space-x-4 ${props.className}`}>
            <div>
            {
                props.category?.[FRMDATA_CATEGORY_THUMBNAIL] && 
                <img
                    src={props.category[FRMDATA_CATEGORY_THUMBNAIL]} 
                    alt={props.title ?? props.altTitle} 
                    className={`sb3-aspect-square sb3-rounded
                        ${activePage?.[PAGE_LAYOUT] !== PAGE_LAYOUTS.GUIDED_SELLING ? "sb3-max-w-[60px] sb3-w-[60px]" : "sb3-max-w-[100px] sb3-w-[100px]"} lg:sb3-max-w-[100px] lg:sb3-w-[100px]
                        ${props.category[FRMDATA_IMAGE_DISPLAY] === "Fill" ? "sb3-object-cover" : "sb3-object-contain"}`}
                />
            }
            </div>
            <div className="sb3-space-y-1">
                <h4 style={{ color: builderSpec?.[BUILDER_CONFIG]?.[CONFIG_CUSTOMIZATION]?.[CUSTOMIZATION_THEME_SETTINGS]?.[THEME_TITLE] }} className="sb3-text-lg sb3-font-bold sb3-select-category-text">
                    {props.title ?? `Select ${props.altTitle}`}{props.isRequired && <span className="sb3-text-danger">*</span>}
                </h4>
                <p>Compatibility based on selections in your build</p>

                {
                    props.showSort &&
                    <div className={`${activePage?.[PAGE_LAYOUT] !== PAGE_LAYOUTS.GUIDED_SELLING && "sb3-hidden"} lg:sb3-inline sb3-items-center lg:sb3-gap-1`}>
                        <SB2Sort
                            category={props.category} 
                            categorySort={props.categorySort}
                            setCategorySort={props.setCategorySort}
                        />
                    </div>
                }
            </div>
        </div>
    )
}

export default CategoryTitle